// extracted by mini-css-extract-plugin
module.exports = {"sideBarWrapper":"sidebar_sideBarWrapper__1VWzA"};